import {Component, Input} from '@angular/core';
import * as moment from 'moment/moment';
import {MetricOptionModel} from '../../../../../models/metric-option.model';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {CommonService} from '../../../../shared/services/common.service';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../state/app.state';
import {EditMetricValueRequest} from '../../core/metrics.actions';
import {MetricValueItem} from '../../models/fetch-metric-values.model';
import * as Validations from '../../../../shared/constants/validation.constants';
import {measurements} from '../../../../shared/constants/common.constants';

@Component({
  selector: 'app-edit-data',
  templateUrl: './edit-data.component.html',
  styleUrls: ['./edit-data.component.css']
})
export class EditDataComponent {
  @Input() data: any;
  maxDate = moment();

  validations = Validations;
  metricOption: MetricOptionModel;
  metricValue: MetricValueItem;
  errorMessages: any = {};
  errorMessageMap = {
    recordedOn: {
      required: 'This field is required.',
      matDatepickerMax: 'Future date is not allowed.'
    },
    value: {
      required: 'This field is required.',
      pattern: 'Invalid value.', // This is for bp metric option
      invalid: 'Systolic or diastolic value must not be zero or empty.', // This is
      // for bp metric option
      min: '', // This is empty as of now, it's required and filled only for
      // metric option height and weight
    },
  }
  form = new FormGroup<any>({
    recordedOn: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
  })

  constants = measurements;

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.metricOption = this.data['metricOption'];
    this.metricValue = this.data['metricValue'];

    // if option is bp then add bp regex validator and valid bp validator
    if (this.metricOption.code === this.constants.metricOption.bp) {
      this.form.controls['value'].addValidators([
        Validators.pattern(this.validations.measurements.bp.regex),
        this.customBPValidator.bind(this),
      ])
    }
    // if option is height then add min height validator
    if (this.metricOption.code === this.constants.metricOption.height) {
      this.errorMessageMap.value.min = 'Height must be minimum half feet.';
      this.form.controls['value'].addValidators([
        Validators.min(this.validations.measurements.height.min),
      ])
    }
    // if option is weight then add min weight validator
    if (this.metricOption.code === this.constants.metricOption.weight) {
      this.errorMessageMap.value.min = 'Weight must be minimum 1 pound.';
      this.form.controls['value'].addValidators([
        Validators.min(this.validations.measurements.weight.min),
      ])
    }

    this.form.patchValue({
      recordedOn: this.metricValue.recordedOn,
      value: this.metricValue.value,
    })
  }

  handleSubmit() {
    if (this.form.invalid) {
      this.errorMessages = this.commonService.checkFormValidation(this.form, this.errorMessageMap);
      return;
    }

    if (!this.form.dirty) {
      this.commonService.closeDialog();
      return;
    }

    const rawValue = this.form.getRawValue();

    // call edit api
    this.store.dispatch(EditMetricValueRequest({
      payload: {
        valueId: this.metricValue.id,
        ...rawValue,
        extras: this.data['extras'],
      }
    }))
  }

  handleCancel() {
    this.commonService.closeDialog();
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  customBPValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value) {
      const valueParts = control.value.split('/');
      if (valueParts.length !== 2) {
        return null;
      }
      const [systolic, diastolic] = valueParts;
      if (!(+systolic) || !(+diastolic)) { // one of the value is 0 then
        return {invalid: true};
      }
    }
    return null;
  }
}
